/**
 * Brücke zwischen CSS-Tokens und Canvas.
 *
 * Das Canvas kann keine CSS-Variablen benutzen, deshalb werden die Tokens
 * einmal ausgelesen und gecacht. Bei Themewechsel `invalidatePalette()`
 * aufrufen — sonst zeichnet die Karte weiter in den alten Farben.
 */

export interface Palette {
  canvasBg: string;
  grid: string;
  route: string;
  nodeFill: string;
  ink: string;
  muted: string;
  coral: string;
  city: string;
  transfer: string;
  holz: string;
  erz: string;
  werkzeug: string;
  truckEmpty: string;
  success: string;
  warning: string;
  error: string;
  surface: string;
}

const TOKENS: Record<keyof Palette, string> = {
  canvasBg: "--canvas",
  grid: "--map-grid",
  route: "--map-route",
  nodeFill: "--map-node-fill",
  ink: "--ink",
  muted: "--muted",
  coral: "--coral",
  city: "--city",
  transfer: "--transfer",
  holz: "--good-holz",
  erz: "--good-erz",
  werkzeug: "--good-werkzeug",
  truckEmpty: "--truck-empty",
  success: "--success",
  warning: "--warning",
  error: "--error",
  surface: "--surface",
};

let cache: Palette | null = null;

export function invalidatePalette(): void {
  cache = null;
}

export function palette(): Palette {
  if (cache) return cache;
  const cs = getComputedStyle(document.documentElement);
  const out = {} as Palette;
  for (const key of Object.keys(TOKENS) as (keyof Palette)[]) {
    out[key] = cs.getPropertyValue(TOKENS[key]).trim() || "#000";
  }
  cache = out;
  return out;
}

/** Farbe einer Ware — nutzt denselben Tokenschlüssel wie GOODS.token. */
export function goodColor(token: string): string {
  const p = palette();
  if (token === "good-holz") return p.holz;
  return token === "good-erz" ? p.erz : p.werkzeug;
}
